export default function NotificationIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.29 16.29L18 15V12.5C18 9.43 16.36 6.86 13.5 6.18V5.5C13.5 4.67 12.83 4 12 4C11.17 4 10.5 4.67 10.5 5.5V6.18C7.62999 6.86 5.99999 9.42 5.99999 12.5V15L4.70999 16.29C4.07999 16.92 4.51999 18 5.40999 18H18.58C19.48 18 19.92 16.92 19.29 16.29ZM16 16H7.99999V12.5C7.99999 10.02 9.50999 8 12 8C14.49 8 16 10.02 16 12.5V16ZM12 21C13.1 21 14 20.1 14 19H9.99999C9.99999 19.5304 10.2107 20.0391 10.5858 20.4142C10.9609 20.7893 11.4696 21 12 21Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
